import { motion } from "framer-motion";
import { SERVICES } from "../../data";
import { ArrowUpRight } from "lucide-react";

const card = {
  hidden: { opacity: 0, y: 50 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  }),
};

const ServiceCard = ({ s, i }) => (
  <motion.article
    data-testid={`service-card-${s.id}`}
    data-cursor
    custom={i}
    variants={card}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.25 }}
    className={`group relative overflow-hidden border border-white/10 bg-[#0e0e0e] transition-colors duration-500 hover:border-[var(--volt)]/60 ${s.span}`}
  >
    <div className="relative h-56 overflow-hidden md:h-64">
      <img
        src={s.image}
        alt={s.title}
        className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0e0e0e] via-[#0e0e0e]/20 to-transparent" />
      <span className="absolute right-5 top-5 font-display text-5xl font-black text-stroke-strong">
        {s.no}
      </span>
    </div>

    <div className="p-7 md:p-9">
      <span className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--volt)]">
        {s.tag}
      </span>
      <h3 className="mt-3 flex items-center justify-between font-display text-2xl font-bold text-white md:text-3xl">
        {s.title}
        <ArrowUpRight className="text-white/30 transition-all duration-300 group-hover:text-[var(--volt)] group-hover:-translate-y-1 group-hover:translate-x-1" />
      </h3>
      <p className="mt-4 max-w-lg text-base leading-relaxed text-white/60">
        {s.desc}
      </p>
      <div className="mt-6 flex flex-wrap gap-2">
        {s.points.map((p) => (
          <span
            key={p}
            className="rounded-full border border-white/15 px-3 py-1.5 font-mono text-[11px] uppercase tracking-wider text-white/70"
          >
            {p}
          </span>
        ))}
      </div>
    </div>
  </motion.article>
);

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services"
      className="mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-32"
    >
      <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--volt)]">
            / What we do
          </span>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase tracking-tight text-white md:text-6xl">
            Three obsessions
          </h2>
        </div>
        <p className="max-w-sm text-base text-white/60 md:text-lg">
          Every service runs the same protocol on the same imported hardware —
          whichever city you&apos;re in.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.id} s={s} i={i} />
        ))}
      </div>
    </section>
  );
};
